// This is a Mixin that extends the base functionality
// of MpNews Controller, for public news page (not registered users)
var MpPublicNews = {
    created: function () {},
    data: function() {
        return {
            NEWS_PAGE_URL: '/news/format/json/page/',
        };
    },
    computed: {
        requestURL: function() {
            return this.NEWS_PAGE_URL + this.page;
        }
    },
    methods: {

        loadItems: function() {
            axios
                .post(this.requestURL)
                .then(this.onItemsLoaded)
                .catch(function(error) {
                    console.log(error);
                });
        },
    },

    mounted: function() {
        this.$refs.ssrItemList.querySelectorAll('.js-item').forEach(this.addDomItem);
    }
};
